import React, { Component } from 'react';
import TutorProfileLayout from './TutorProfileLayout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import Skeleton from '@material-ui/lab/Skeleton';
import { history } from '../../../../helpers';
import { itemService, globalService as gs } from '../../../../common/services';
import { alertSelectors } from '../../../../common/redux/selectors';
import AvailibilityForm from './partials/AvailibilityForm';
import { Link } from 'react-router-dom';

class SetAvailability extends Component {

    constructor(props) {
        super(props);
        this.state = {
            allList: [],
            loading: false
        };
    }

    componentDidMount() {
        this.loadAvalibility();
        localStorage.setItem('activeStep', 3);
    } 

    loadAvalibility = (loading = true) => {
        const { dispatch } = this.props;
        this.setState({loading: loading});
        itemService.availability("GET").then(data => {
            let list = data.items;
            this.setState({allList: list, loading: false});
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({loading: false});
        });
    }

    AddClick = (event) => {
        let object  = { week_day: event, start_time: '', end_time: '', status: 1, blank_id: Math.floor((Math.random() * 10000) + 1) };
        this.setState({
            ...this.state,
            allList: [...this.state.allList, object],
        });
    }

    RemoveClick = (event, index) => {
        if(index) {
            this.setState({
                ...this.state,
                allList: [...this.state.allList.filter( val => parseInt(val.id) !== parseInt(event.id) )]
            });
        } else {
            this.setState({
                ...this.state,
                allList: [...this.state.allList.filter( val => parseInt(val.blank_id) !== parseInt(event.blank_id) )]
            });
        }
    }

    UpdateClick = () => {
        this.loadAvalibility(false);
    }



    nextButton = () => {
        localStorage.setItem('activeStep', 4);
        history.push('/tutor/payment-details');
    };

    backButton = () => {
        localStorage.setItem('activeStep', 2);
        history.push('/tutor/set-prices');
    }

    render() {
        const { allList, loading } = this.state;
        const chageList = allList && allList.map(item => {
            return {
                id: item.id,
                created_at: item.created_at,
                status: item.status,
                updated_at: item.updated_at,
                user: item.user,
                user_id: item.user_id,
                week_day: item.week_day,
                start_time: gs.convertTimestamptoTime(item.start_time),
                end_time: gs.convertTimestamptoTime(item.end_time),
                blank_id: item && item.blank_id
            }
        });

        const Monday = chageList && chageList.filter(item => (item.week_day === 'Monday'));
        const Tuesday = chageList && chageList.filter(item => (item.week_day === 'Tuesday'));
        const Wednesday = chageList && chageList.filter(item => (item.week_day === 'Wednesday'));
        const Thursday = chageList && chageList.filter(item => (item.week_day === 'Thursday'));
        const Friday = chageList && chageList.filter(item => (item.week_day === 'Friday'));
        const Saturday = chageList && chageList.filter(item => (item.week_day === 'Saturday'));
        const Sunday = chageList && chageList.filter(item => (item.week_day === 'Sunday'));

        return (<TutorProfileLayout activeClass="TutorProfile">
            <div className="availibility-page p-lg-4">
                <h2 className="py-3">Availability</h2>

                {loading ? <div>
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="text" width="100%" />
                    <Skeleton variant="text" width="100%" />
                </div> : <> 
                    <div className="row">
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <div className="row">
                                <AvailibilityForm day="Monday" Items={Monday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                            <div className="row">
                                <AvailibilityForm day="Tuesday" Items={Tuesday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                            <div className="row">
                                <AvailibilityForm day="Wednesday" Items={Wednesday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                            <div className="row">
                                <AvailibilityForm day="Thursday" Items={Thursday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                            <div className="row">
                                <AvailibilityForm day="Friday" Items={Friday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                            <div className="row">
                                <AvailibilityForm day="Saturday" Items={Saturday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                            <div className="row">
                                <AvailibilityForm day="Sunday" Items={Sunday} Add={this.AddClick} Remove={this.RemoveClick} Update={this.UpdateClick} />
                            </div>
                        </div>
                    </div>    
                </>}
                <div className="form-group text-center">
                    <button className="btn btn-primary mx-2 mb-3" type="submit" onClick={this.backButton}>Back</button>
                    <button className="btn btn-info mx-2 text-uppercase mb-3" onClick={this.nextButton}>Next</button>
                    <Link to="/tutor/custom-unavailability" className="btn btn-info ml-2 mb-3 text-uppercase">Custom Unavailability</Link>
                    <hr />
                </div>
                <div className="row">
                    <div className="col-lg-8 col-md-12 col-12 text-center mx-auto">
                        <img src="/images/b-tutor.png" width="100%"/>
                    </div>
                </div>    
            </div>
        </TutorProfileLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);
const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(SetAvailability);
